<template>
  <form>
    <select-field
      v-model="innerReportType"
      name="レポート種類"
      label="レポート種類"
      rules="required"
      :class="`${(innerReportType == null) ? 'no-category-selected' : ''}`"
      :options="optionReportType"
      :disabled="isEdit"
      :searchable="false"
      full-width
      return-object
    />
    <div v-if="innerReportType != null" class="mt-4">
      <input-field
        v-model="innerReportName"
        name="レポート名"
        label="レポート名"
        rules="required|max:100"
        full-width
      />
      <div v-if="innerReportType.value === 11">
        <select-field
          v-model="innerEvent"
          name="イベント"
          label="イベント"
          rules="required"
          class="mt-4"
          :options="optionEvent"
          :max-result-shown="10"
          :disabled="isEdit"
          multiple
          full-width
        />
        <div class="vx-row items-end">
          <div class="vx-col w-2/5">
            <input-field
              v-model="innerFrequency"
              name="フリークエンシー"
              label="フリークエンシー"
              rules="required|integer|min_value:1"
              :disabled="isEdit"
            />
          </div>
          <div class="vx-col w-3/5">
            <span>回以上</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerCategory"
              name="カテゴリー"
              label="カテゴリー"
              class="mt-4"
              :options="optionCategory"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <select-field
              v-model="innerCategories"
              name="カテゴリー名"
              label=" "
              class="mt-4"
              :options="optionCategories"
              :disabled="innerCategory === null || isEdit"
              :max-result-shown="10"
              full-width
              multiple
            />
          </div>
        </div>
        <text-area-field
          v-model="innerAsin"
          class="mt-4"
          name="ASIN"
          label="ASIN"
          placeholder="改行で複数ASINの一括登録が可能"
          rows="5"
          :disabled="isEdit"
          full-width
        />
        <div class="vx-row mt-4">
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerBeforeDate"
              name="開始日"
              label="期間"
              rules="required"
              :min-date="minDate"
              :max-date="maxDate"
              :disabled="isEdit"
              full-width
            />
          </div>
          <div class="vx-col justify-center items-center w-1/2">
            <DateField
              v-model="innerAfterDate"
              name="終了日"
              rules="required"
              :min-date="minDate"
              :max-date="maxDate"
              :disabled="isEdit"
              full-width
            />
          </div>
        </div>
      </div>
      <div v-if="innerReportType.value === 13">
        <select-field
          v-model="innerEcUserCategory1"
          name="カテゴリー1"
          label="カテゴリー1"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory1"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory2"
          name="カテゴリー2"
          label="カテゴリー2"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory2"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory3"
          name="カテゴリー3"
          label="カテゴリー3"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory3"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory4"
          name="カテゴリー4"
          label="カテゴリー4"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory4"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
        <select-field
          v-model="innerEcUserCategory5"
          name="カテゴリー5"
          label="カテゴリー5"
          rules=""
          class="mt-4"
          :options="optionEcUserCategory5"
          :max-result-shown="100"
          :disabled="isEdit"
          full-width
          multiple
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import InputField from '@/components/fields/InputField';
import SelectField from '@/components/fields/SelectField';
import TextAreaField from '@/components/fields/TextAreaField';
import DateField from '@/components/fields/DateField';
import AMC_REPORT_TYPE from '@/constants/AmcReportType';

export default {
  name: 'AmcAffinityReportForm',
  components: {
    InputField,
    SelectField,
    TextAreaField,
    DateField,
  },
  props: {
    reportType: {
      type: Object,
      default: null
    },
    reportName: {
      type: String,
      default: null,
    },
    event: {
      type: Array,
    },
    frequency: {
      type: String,
      default: null,
    },
    category: {
      type: String,
      default: null,
    },
    categories: {
      type: Array,
    },
    beforeDate: {
      type: String,
      default: null,
    },
    afterDate: {
      type: String,
      default: null,
    },
    asin: {
      type: String,
      default: null,
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    category1: {
      type: Array,
      default () {
        return []
      }
    },
    category2: {
      type: Array,
      default () {
        return []
      }
    },
    category3: {
      type: Array,
      default () {
        return []
      }
    },
    category4: {
      type: Array,
      default () {
        return []
      }
    },
    category5: {
      type: Array,
      default () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:report-type',
    'update:report-name',
    'update:event',
    'update:frequency',
    'update:category',
    'update:categories',
    'update:asin',
    'update:before-date',
    'update:after-date',
    'update:category1',
    'update:category2',
    'update:category3',
    'update:category4',
    'update:category5',
  ],
  data() {
    return {};
  },
  computed: {
    ...mapState('amcAffinityReports', ['categoriesList', 'minStartDay', 'ecUserCategories']),
    ...mapState('amcProfile', ['activeAmcProfile']),
    innerReportType: {
      get () {
        return this.reportType
      },
      set (val) {
        this.$emit('update:report-type', val)
      }
    },
    innerReportName: {
      get() {
        return this.reportName;
      },
      set(val) {
        this.$emit('update:report-name', val);
      },
    },
    innerEvent: {
      get() {
        return this.event;
      },
      set(val) {
        this.$emit('update:event', val);
      },
    },
    innerFrequency: {
      get() {
        return this.frequency;
      },
      set(val) {
        this.$emit('update:frequency', val);
      },
    },
    innerCategory: {
      get() {
        return this.category;
      },
      set(val) {
        this.$emit('update:category', val);
      },
    },
    innerCategories: {
      get() {
        return this.categories;
      },
      set(val) {
        this.$emit('update:categories', val);
      },
    },
    innerBeforeDate: {
      get() {
        return this.beforeDate;
      },
      set(val) {
        this.$emit('update:before-date', val);
      },
    },
    innerAfterDate: {
      get() {
        return this.afterDate;
      },
      set(val) {
        this.$emit('update:after-date', val);
      },
    },
    innerAsin: {
      get() {
        return this.asin;
      },
      set(val) {
        this.$emit('update:asin', val);
      },
    },
    innerEcUserCategory1: {
      get () {
        return this.category1 || []
      },
      set (val) {
        this.$emit('update:category1', (Array.isArray(val)) ? val : [])
      }
    },
    innerEcUserCategory2: {
      get () {
        return this.category2 || []
      },
      set (val) {
        this.$emit('update:category2', (Array.isArray(val)) ? val : [])
      }
    },
    innerEcUserCategory3: {
      get () {
        return this.category3 || []
      },
      set (val) {
        this.$emit('update:category3', (Array.isArray(val)) ? val : [])
      }
    },
    innerEcUserCategory4: {
      get () {
        return this.category4 || []
      },
      set (val) {
        this.$emit('update:category4', (Array.isArray(val)) ? val : [])
      }
    },
    innerEcUserCategory5: {
      get () {
        return this.category5 || []
      },
      set (val) {
        this.$emit('update:category5', (Array.isArray(val)) ? val : [])
      }
    },
    optionReportType () {
      const reportTypeConditions = [11, 13]
      return Object.keys(AMC_REPORT_TYPE).filter(key => reportTypeConditions.includes(Number(key))).map((key)=> {
        if (Number(key) === 13 && this.ecUserCategories && this.ecUserCategories.hasOwnProperty('disabled')) {
          return {text: AMC_REPORT_TYPE[key], value: Number(key), $isDisabled: this.ecUserCategories['disabled']}
        }
        return {text: AMC_REPORT_TYPE[key], value: Number(key), $isDisabled: false}
      })
    },
    optionEvent() {
      return [
        { text: 'レビューページ閲覧', value: 'customerReview' },
        { text: 'ページビュー', value: 'detailPageView' },
        { text: 'オーダー', value: 'order' },
        { text: 'ショッピングカート', value: 'shoppingCart' },
        { text: '定期便登録', value: 'snsSubscription' },
        { text: '最初の定期便オーダー', value: 'firstSnSOrder' },
        { text: 'リピート定期便オーダー', value: 'repeatSnSOrder' },
      ];
    },
    optionCategory() {
      return [
        { text: 'ブランド', value: 'brand' },
        { text: '出品者カテゴリー', value: 'seller_category' },
        { text: '出品者カテゴリー2', value: 'seller_category2' },
        { text: '出品者カテゴリー3', value: 'seller_category3' },
        { text: '出品者カテゴリー4', value: 'seller_category4' },
        { text: '出品者カテゴリー5', value: 'seller_category5' },
      ];
    },
    optionCategories() {
      if (this.innerCategory === null) return [];
      return this.categoriesList[this.camelC(this.innerCategory)].map((item) => ({ text: item, value: item }));
    },
    optionEcUserCategory1 () {
      return (this.ecUserCategories?.hasOwnProperty('category1')) ?
        this.ecUserCategories['category1'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory2 () {
      return (this.ecUserCategories?.hasOwnProperty('category2')) ?
        this.ecUserCategories['category2'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory3 () {
      return (this.ecUserCategories?.hasOwnProperty('category3')) ?
        this.ecUserCategories['category3'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory4 () {
      return (this.ecUserCategories?.hasOwnProperty('category4')) ?
        this.ecUserCategories['category4'].map((c) => ({text: c, value: c})) : []
    },
    optionEcUserCategory5 () {
      return (this.ecUserCategories?.hasOwnProperty('category5')) ?
        this.ecUserCategories['category5'].map((c) => ({text: c, value: c})) : []
    }
  },
  methods: {
    camelC(string) {
      return string.replace('_c', 'C');
    },
  },
};
</script>
